export default __webpack_public_path__ + "static/media/drag-icon.dd0d8b18.svg";